<template>
    <figure class="journal">
        <div class="relative">
            <a :href="download" :download="download">
                <img :src="img" alt="Journal image"/>
                <div class="hidden-options">
                    <p>
                        <span>{{ descricao }}</span><br>
                        <b>BAIXAR ARQUIVO</b><br>
                        <svg-icon icon="file-alt-light" />
                    </p>
                </div>
            </a>
        </div>
        <figcaption>
            <h3>Jornal</h3>
            <p>{{ descricao }}</p>
        </figcaption>
    </figure>
</template>

<script>
export default {
    name: "journal",
    props: {
        img: String,
        descricao: String,
        download: String,
    },
}
</script>

<style scoped lang="scss">
.journal {
    box-shadow: 5px 5px 5px #e4e4e4;
    min-width: 250px;
    max-width: 250px;
    height: auto;
    @apply mx-auto mb-8 text-center;

    a {
        @apply text-white;
    }
    img{
        @apply bg-dark-gray w-full;
        height: 350px;
    }
    figcaption {
        @apply px-8 py-2;
        h3{
            @apply uppercase text-sm font-bold mb-2;
        }
        p {
            @apply text-xs pb-4;
        }
    }
    .hidden-options {
        @apply absolute hidden w-full h-full text-white leading-10 text-sm top-0 left-0;
        p {
            @apply absolute w-full;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
        span {
            @apply italic uppercase;
        }
        svg {
            width: 28px;
            height: 28px;
            color: #fff;
            @apply mx-auto mt-5;
        }
    }

    img:hover {
        cursor: pointer;
        + .hidden-options{
            display: inline;
            background: linear-gradient(rgba(0, 0, 0, .8), rgba(0, 0, 0, .8));
        }
    }
}
</style>
